import React, { Component, Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Group } from 'api';
import { GroupAvatar, ToggleButton } from 'components';

const styles = (theme: Theme) =>
  createStyles({
    card: {
      marginBottom: 20,
      transition: 'box-shadow 100ms ease-in-out',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: theme.custom.shadows.depth1,
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      height: theme.spacing(10),
      paddingLeft: 0,
      paddingTop: 0,
      '&:last-child': {
        paddingBottom: 0,
      },
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  group: Group;
  isFollowing: boolean;
  onClick: () => void;
}

interface IState {
  hovered: boolean;
}

class GroupCard extends Component<IProps, IState> {
  state: IState = {
    hovered: false,
  };

  handleHover = () => {
    const { hovered } = this.state;
    this.setState({ hovered: !hovered });
  };

  renderTitle() {
    const { classes, group } = this.props;

    return (
      <Fragment>
        <Typography className={classes.title} variant="subtitle2" noWrap>
          {group.title}
        </Typography>
        <Typography color="textSecondary">
          <Trans i18nKey="components:xFollower" count={group.follower_count} />
        </Typography>
      </Fragment>
    );
  }

  render() {
    const { classes, group, isFollowing, onClick } = this.props;
    const { hovered } = this.state;

    return (
      <Card
        className={classes.card}
        onClick={onClick}
        onMouseEnter={this.handleHover}
        onMouseLeave={this.handleHover}>
        <CardContent className={classes.content}>
          <Grid container alignItems="center" wrap="nowrap" spacing={2}>
            <Grid item>
              <GroupAvatar size={80} group={group} square />
            </Grid>
            <Grid item xs zeroMinWidth>
              {this.renderTitle()}
            </Grid>
            <Grid item>
              <ToggleButton selected={isFollowing} parentHovered={hovered} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(GroupCard);
